import { requireEnvironmentVariable } from "./environment";

export const shopifyStoreDomain = requireEnvironmentVariable(
  "GATSBY_SHOPIFY_STORE_DOMAIN",
  process.env.GATSBY_SHOPIFY_STORE_DOMAIN
);

export const shopifyStorefrontAccessToken = requireEnvironmentVariable(
  "GATSBY_SHOPIFY_STOREFRONT_ACCESS_TOKEN",
  process.env.GATSBY_SHOPIFY_STOREFRONT_ACCESS_TOKEN
);
